import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { ErrorToaster, SuccessToaster } from "../Toaster/Toaster";
import { InputField } from "../UI/TextField";
import { PrimaryButton } from "../Buttons/Button";
import DriverPriceService from "app/apis/Goeasy/Driver/DriverPriceService";

function AddNewDriver({ open, handleClose, toggle, handleSubmitFunc }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();

  const submitVehicleForm = async (formData) => {
    try {
      await DriverPriceService.createDriver(formData);
      SuccessToaster("Driver saved successfully");
      resetFormState();
      handleSubmitFunc();
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const prepareVehicleFormData = (data) => {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    submitVehicleForm(formData);
  };

  const resetFormState = () => {
    reset();
  };

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={() => {
        handleClose();
        resetFormState();
      }}
      sx={{ "& .MuiDialog-paper": { borderRadius: 3 } }}
    >
      {/* ================= Title ================= */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 600,
        }}
      >
        {toggle ? "Edit Driver" : "Add New Driver"}
        <IconButton
          onClick={() => {
            handleClose();
            resetFormState();
          }}
        >
          <CloseRounded />
        </IconButton>
      </DialogTitle>

      <Divider />

      {/* ================= Content ================= */}
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit(prepareVehicleFormData)}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <InputField
                label="Driver Name"
                error={errors?.name?.message}
                register={register("name", {
                  required: "Driver name is required",
                })}
              />
            </Grid>

            <Grid item xs={6}>
              <InputField
                label="Phone Number"
                error={errors?.contact_no?.message}
                register={register("contact_no", {
                  required: "Phone number is required",
                })}
              />
            </Grid>
          </Grid>

          {/* ================= Submit ================= */}
          <PrimaryButton
            loading={isSubmitting}
            type="submit"
            title="Save Driver"
            fullWidth
            myStyle={{ mt: 2, borderRadius: 2 }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AddNewDriver;
